<template>
  <div>
    <TabDescription
      :text="$t('vp_countries_subtext')"
      :note="$t('vp_data_info')"
    />
    <CountriesView />
  </div>
</template>
<script setup>
import TabDescription from '@/components/visitorsProfile/common/TabDescription.vue'
import CountriesView from '@/components/visitorsProfile/countries/CountriesView.vue'
</script>
